export const addUp = (sum, value) => {
    return sum + value;
};

export const getWorkingDaysPerYear = (year, normalWorkdaysWeek) => {
    const mapping = {
        0: 6, // Sunday
        1: 0, // Monday
        2: 1, // Tuesday
        3: 2, // Wednesday
        4: 3, // Thursday
        5: 4, // Friday
        6: 5, // Saturday
    };

    const isWeekday = (dayOfWeek, normalWorkdaysWeek) => {
        return dayOfWeek < normalWorkdaysWeek;
    };

    let totalWorkingDays = 0;
    let currentDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31);

    while (currentDate <= endDate) {
        const dayOfWeek = mapping[currentDate.getDay()];
        if (isWeekday(dayOfWeek, normalWorkdaysWeek)) {
            const halfDay = normalWorkdaysWeek - dayOfWeek;
            if (halfDay < 1) {
                totalWorkingDays += halfDay;
            } else {
                totalWorkingDays += 1;
            }
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return totalWorkingDays;
};
